import {useSyncExternalStore as $6Pyhu$useSyncExternalStore, useRef as $6Pyhu$useRef, useCallback as $6Pyhu$useCallback} from "react";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $b4d6e04d4e1b433b$exports = {};

$parcel$export($b4d6e04d4e1b433b$exports, "STATUS_PENDING", () => $b4d6e04d4e1b433b$export$102c3f975dbe36bd);
$parcel$export($b4d6e04d4e1b433b$exports, "STATUS_RESOLVED", () => $b4d6e04d4e1b433b$export$95b9efe7da5fb195);
$parcel$export($b4d6e04d4e1b433b$exports, "STATUS_REJECTED", () => $b4d6e04d4e1b433b$export$89864f7e9466db1c);
const $b4d6e04d4e1b433b$export$102c3f975dbe36bd = "pending";
const $b4d6e04d4e1b433b$export$95b9efe7da5fb195 = "resolved";
const $b4d6e04d4e1b433b$export$89864f7e9466db1c = "rejected";


var $038032e94f37c99b$exports = {};

$parcel$export($038032e94f37c99b$exports, "createCache", () => $038032e94f37c99b$export$cf6fa0bbcc94b912);

var $4d5cae46926c5773$exports = {};

$parcel$export($4d5cae46926c5773$exports, "createDeferred", () => $4d5cae46926c5773$export$e673efccd97e4223);
let $4d5cae46926c5773$var$MAX_LOOP_COUNT = 1000;
function $4d5cae46926c5773$export$e673efccd97e4223(debugLabel) {
    const resolveCallbacks = new Set();
    const rejectCallbacks = new Set();
    let status = "unresolved";
    let data = null;
    let callbacksRegisteredAfterResolutionCount = 0;
    // Guard against a case where promise resolution results in a new deferred listener being added.
    // That cause would result in an infinite loop.
    // Note that our guard counter should be somewhat high to avoid false positives.
    // It is a legitimate use-case to register handlers after a deferred has been resolved or rejected.
    const checkCircularThenableChain = ()=>{
        if (++callbacksRegisteredAfterResolutionCount > $4d5cae46926c5773$var$MAX_LOOP_COUNT) throw Error(`Circular thenable chain detected (infinite loop) for resource: ${debugLabel}`);
    };
    const deferred = {
        then (resolveCallback, rejectCallback) {
            switch(status){
                case "unresolved":
                    resolveCallbacks.add(resolveCallback);
                    rejectCallbacks.add(rejectCallback);
                    break;
                case "rejected":
                    checkCircularThenableChain();
                    rejectCallback(data);
                    break;
                case "resolved":
                    checkCircularThenableChain();
                    resolveCallback(data);
                    break;
            }
        },
        reject (error) {
            if (status !== "unresolved") throw Error(`Deferred has already been ${status}`);
            status = "rejected";
            data = error;
            rejectCallbacks.forEach((rejectCallback)=>{
                let thrownValue = null;
                try {
                    rejectCallback(error);
                } catch (error1) {
                    thrownValue = error1;
                }
                if (thrownValue !== null) throw thrownValue;
            });
            rejectCallbacks.clear();
            resolveCallbacks.clear();
        },
        resolve (value) {
            if (status !== "unresolved") throw Error(`Deferred has already been ${status}`);
            status = "resolved";
            data = value;
            resolveCallbacks.forEach((resolveCallback)=>{
                let thrownValue = null;
                try {
                    resolveCallback(value);
                } catch (error) {
                    thrownValue = error;
                }
                if (thrownValue !== null) throw thrownValue;
            });
            rejectCallbacks.clear();
            resolveCallbacks.clear();
        }
    };
    return deferred;
}



function $e2d2607e556ddad7$export$a7a9523472993e97(expectedCondition, message = "Assertion failed!") {
    if (!expectedCondition) {
        console.error(message);
        throw Error(message);
    }
}


function $fbad927ef8185060$export$5720014d5c94137d(record) {
    (0, $e2d2607e556ddad7$export$a7a9523472993e97)(record.status === (0, $b4d6e04d4e1b433b$export$102c3f975dbe36bd));
    return true;
}


var $e6e092424a433191$exports = {};

$parcel$export($e6e092424a433191$exports, "isThennable", () => $e6e092424a433191$export$f8dbb9c12951c723);
function $e6e092424a433191$export$f8dbb9c12951c723(value) {
    return value != null && typeof value.then === "function";
}


function $038032e94f37c99b$export$cf6fa0bbcc94b912(getKey, load, debugLabel) {
    const recordMap = new Map();
    const subscriberMap = new Map();
    function cache(value, ...params) {
        const cacheKey = getKey(...params);
        const record = {
            status: (0, $b4d6e04d4e1b433b$export$95b9efe7da5fb195),
            value: value
        };
        recordMap.set(cacheKey, record);
    }
    function evict(...params) {
        const cacheKey = getKey(...params);
        return recordMap.delete(cacheKey);
    }
    function getOrCreateRecord(...params) {
        const cacheKey = getKey(...params);
        let record = recordMap.get(cacheKey);
        if (record == null) {
            const deferred = (0, $4d5cae46926c5773$export$e673efccd97e4223)(debugLabel ? `${debugLabel} ${cacheKey}}` : cacheKey);
            record = {
                status: (0, $b4d6e04d4e1b433b$export$102c3f975dbe36bd),
                value: deferred
            };
            recordMap.set(cacheKey, record);
            notifySubscribers(...params);
            processPendingRecord(record, ...params);
        }
        return record;
    }
    function getStatus(...params) {
        const cacheKey = getKey(...params);
        const record = recordMap.get(cacheKey);
        return record === null || record === void 0 ? void 0 : record.status;
    }
    function getValue(...params) {
        const cacheKey = getKey(...params);
        const record = recordMap.get(cacheKey);
        if (record == null) throw Error("No record found");
        else if (record.status !== (0, $b4d6e04d4e1b433b$export$95b9efe7da5fb195)) throw Error(`Record found with status "${record.status}"`);
        else return record.value;
    }
    function getValueIfCached(...params) {
        const cacheKey = getKey(...params);
        const record = recordMap.get(cacheKey);
        if ((record === null || record === void 0 ? void 0 : record.status) === (0, $b4d6e04d4e1b433b$export$95b9efe7da5fb195)) return record.value;
    }
    function prefetch(...params) {
        fetchAsync(...params);
    }
    function fetchAsync(...params) {
        const record = getOrCreateRecord(...params);
        switch(record.status){
            case 0, $b4d6e04d4e1b433b$export$102c3f975dbe36bd:
            case 0, $b4d6e04d4e1b433b$export$95b9efe7da5fb195:
                return record.value;
            case 0, $b4d6e04d4e1b433b$export$89864f7e9466db1c:
                throw record.value;
        }
    }
    function fetchSuspense(...params) {
        const record = getOrCreateRecord(...params);
        if (record.status === (0, $b4d6e04d4e1b433b$export$95b9efe7da5fb195)) return record.value;
        else throw record.value;
    }
    function notifySubscribers(...params) {
        const cacheKey = getKey(...params);
        const set = subscriberMap.get(cacheKey);
        if (set) {
            const status = getStatus(...params);
            set.forEach((callback)=>{
                callback(status);
            });
        }
    }
    async function processPendingRecord(record, ...params) {
        (0, $fbad927ef8185060$export$5720014d5c94137d)(record);
        const deferred = record.value;
        try {
            const valueOrThennable = load(...params);
            const value = (0, $e6e092424a433191$export$f8dbb9c12951c723)(valueOrThennable) ? await valueOrThennable : valueOrThennable;
            record.status = (0, $b4d6e04d4e1b433b$export$95b9efe7da5fb195);
            record.value = value;
            deferred.resolve(value);
        } catch (error) {
            record.status = (0, $b4d6e04d4e1b433b$export$89864f7e9466db1c);
            record.value = error;
            deferred.reject(error);
        } finally{
            notifySubscribers(...params);
        }
    }
    function subscribeToStatus(callback, ...params) {
        const cacheKey = getKey(...params);
        let set = subscriberMap.get(cacheKey);
        if (set) set.add(callback);
        else {
            set = new Set([
                callback
            ]);
            subscriberMap.set(cacheKey, set);
        }
        try {
            const status = getStatus(...params);
            callback(status);
        } finally{
            return ()=>{
                set.delete(callback);
                if (set.size === 0) subscriberMap.delete(cacheKey);
            };
        }
    }
    return {
        cache: cache,
        evict: evict,
        getStatus: getStatus,
        getValue: getValue,
        getValueIfCached: getValueIfCached,
        fetchAsync: fetchAsync,
        fetchSuspense: fetchSuspense,
        prefetch: prefetch,
        subscribeToStatus: subscribeToStatus
    };
}


var $9f18d97897599eb1$exports = {};

$parcel$export($9f18d97897599eb1$exports, "createStreamingCache", () => $9f18d97897599eb1$export$ea911cd21ad60992);


function $1a3e0135b59678f3$export$f483e9abc61a334f(expectedCondition, message) {}


function $9f18d97897599eb1$export$ea911cd21ad60992(getKey, load, debugLabel) {
    const streamingValuesMap = new Map();
    function evict(...params) {
        const cacheKey = getKey(...params);
        return streamingValuesMap.delete(cacheKey);
    }
    function getOrCreateStreamingValues(...params) {
        const cacheKey = getKey(...params);
        let cached = streamingValuesMap.get(cacheKey);
        if (cached == null) {
            const resolver = (0, $4d5cae46926c5773$export$e673efccd97e4223)(debugLabel ? `${debugLabel}: ${cacheKey}` : cacheKey);
            const subscribers = new Set();
            const streamingValues = {
                complete: false,
                data: undefined,
                progress: undefined,
                resolver: resolver,
                status: (0, $b4d6e04d4e1b433b$export$102c3f975dbe36bd),
                subscribe: (callback)=>{
                    subscribers.add(callback);
                    return ()=>{
                        subscribers.delete(callback);
                    };
                },
                values: undefined
            };
            const notifySubscribers = ()=>{
                subscribers.forEach((subscriber)=>{
                    try {
                        subscriber();
                    } catch (error) {}
                });
            };
            const assertIncomplete = ()=>{
                if (streamingValues.complete) throw Error(`Stream has already been ${streamingValues.status}`);
            };
            const notifier = {
                update: (values, progress, data)=>{
                    assertIncomplete();
                    streamingValues.data = data;
                    if (streamingValues.values == null) streamingValues.values = [
                        ...values
                    ];
                    else streamingValues.values = streamingValues.values.concat(...values);
                    if (progress != null) {
                        (0, $1a3e0135b59678f3$export$f483e9abc61a334f)(progress >= 0 && progress <= 1, `Invalid progress: ${progress}; value must be between 0-1.`);
                        streamingValues.progress = progress;
                    }
                    notifySubscribers();
                },
                resolve: ()=>{
                    assertIncomplete();
                    streamingValues.complete = true;
                    streamingValues.progress = 1;
                    streamingValues.status = (0, $b4d6e04d4e1b433b$export$95b9efe7da5fb195);
                    notifySubscribers();
                    resolver.resolve(streamingValues);
                },
                reject: (error)=>{
                    assertIncomplete();
                    streamingValues.complete = true;
                    streamingValues.status = (0, $b4d6e04d4e1b433b$export$89864f7e9466db1c);
                    notifySubscribers();
                    resolver.reject(error);
                }
            };
            streamingValuesMap.set(cacheKey, streamingValues);
            load(notifier, ...params);
            return streamingValues;
        }
        return cached;
    }
    function prefetch(...params) {
        getOrCreateStreamingValues(...params);
    }
    function stream(...params) {
        return getOrCreateStreamingValues(...params);
    }
    return {
        evict: evict,
        prefetch: prefetch,
        stream: stream
    };
}


var $f0095c6fdcdc5fd0$exports = {};

$parcel$export($f0095c6fdcdc5fd0$exports, "useCacheStatus", () => $f0095c6fdcdc5fd0$export$a0b0284d625c6d1d);

function $f0095c6fdcdc5fd0$export$a0b0284d625c6d1d(cache, ...params) {
    return (0, $6Pyhu$useSyncExternalStore)((callback)=>cache.subscribeToStatus(callback, ...params), ()=>cache.getStatus(...params), ()=>cache.getStatus(...params));
}


var $3ef79ba379079bd7$exports = {};

$parcel$export($3ef79ba379079bd7$exports, "useStreamingValues", () => $3ef79ba379079bd7$export$8433da63a5f207fd);

function $ecaf1857cf086d2f$export$de363e709c412c8a(callback, throttleByAmount) {
    let lastCalledAt = -Infinity;
    let timeoutId = null;
    const throttled = (...args)=>{
        const elapsed = performance.now() - lastCalledAt;
        if (elapsed >= throttleByAmount) {
            lastCalledAt = performance.now();
            callback(...args);
        } else {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(()=>{
                lastCalledAt = performance.now();
                callback(...args);
            }, throttleByAmount - elapsed);
        }
    };
    throttled.cancel = ()=>{
        clearTimeout(timeoutId);
    };
    return throttled;
}


function $3ef79ba379079bd7$export$8433da63a5f207fd(streamingValues, options = {}) {
    const { throttleUpdatesBy: throttleUpdatesBy = 500  } = options;
    const ref = (0, $6Pyhu$useRef)({
        complete: false,
        data: undefined,
        progress: 0,
        values: undefined
    });
    const getValue = ()=>{
        const value = ref.current;
        if (value.complete !== streamingValues.complete || value.data !== streamingValues.data || value.progress !== streamingValues.progress || value.values !== streamingValues.values) ref.current = {
            complete: streamingValues.complete,
            data: streamingValues.data,
            progress: streamingValues.progress,
            values: streamingValues.values
        };
        return ref.current;
    };
    const throttledSubscribe = (0, $6Pyhu$useCallback)((callback)=>{
        const callbackWrapper = (0, $ecaf1857cf086d2f$export$de363e709c412c8a)(callback, throttleUpdatesBy);
        return streamingValues.subscribe(callbackWrapper);
    }, [
        streamingValues.subscribe,
        throttleUpdatesBy
    ]);
    return (0, $6Pyhu$useSyncExternalStore)(throttledSubscribe, getValue, getValue);
}



var $5663ad6d0c025dca$exports = {};

$parcel$export($5663ad6d0c025dca$exports, "createInfallibleCache", () => $5663ad6d0c025dca$export$f0e4809aa1287def);

function $5663ad6d0c025dca$export$f0e4809aa1287def(suspenseCache) {
    return function createInfallibleSuspenseCache(...params) {
        try {
            return suspenseCache(...params);
        } catch (errorOrThennable) {
            if ((0, $e6e092424a433191$export$f8dbb9c12951c723)(errorOrThennable)) throw errorOrThennable;
            else return undefined;
        }
    };
}



var $21804676a98929ef$exports = {};

$parcel$export($21804676a98929ef$exports, "parallelize", () => $21804676a98929ef$export$ea1b43b85e3a4fd8);
function $21804676a98929ef$export$ea1b43b85e3a4fd8(...callbacks) {
    const values = [];
    let thrownValue = null;
    callbacks.forEach((callback)=>{
        try {
            values.push(callback());
        } catch (error) {
            thrownValue = error;
        }
    });
    if (thrownValue !== null) throw thrownValue;
    return values;
}


var $fbba0c634a17eace$exports = {};




export {$b4d6e04d4e1b433b$export$102c3f975dbe36bd as STATUS_PENDING, $b4d6e04d4e1b433b$export$95b9efe7da5fb195 as STATUS_RESOLVED, $b4d6e04d4e1b433b$export$89864f7e9466db1c as STATUS_REJECTED, $038032e94f37c99b$export$cf6fa0bbcc94b912 as createCache, $9f18d97897599eb1$export$ea911cd21ad60992 as createStreamingCache, $f0095c6fdcdc5fd0$export$a0b0284d625c6d1d as useCacheStatus, $3ef79ba379079bd7$export$8433da63a5f207fd as useStreamingValues, $4d5cae46926c5773$export$e673efccd97e4223 as createDeferred, $5663ad6d0c025dca$export$f0e4809aa1287def as createInfallibleCache, $e6e092424a433191$export$f8dbb9c12951c723 as isThennable, $21804676a98929ef$export$ea1b43b85e3a4fd8 as parallelize};
//# sourceMappingURL=suspense.module.js.map
